module.exports = __webpack_public_path__ + "static/media/sign-in.91194a57.svg";